import { isIOS } from "react-device-detect";
import styled from "styled-components";

export const defaultTextColor = "#073670";

export const SectionTitle = styled.div`
	font-weight: 600;
	font-size: 20px;
	line-height: 30px;
	color: ${defaultTextColor};
	display: flex;
	align-items: center;
	margin: 10px 0px 0px 0px;
	font-family: Baloo;
	font-size: 26px;
	font-style: normal;
	font-weight: 400;
	line-height: 40px;

	@media (min-width: 550px) {
		font-size: 34px;
	}
`;

export const SectionIconContainer = styled.div`
	display: flex;
	align-items: center;
	margin: 5px;
`;

export const CardFinalMessage = styled.div<{
	fontSize?: string;
	opacity?: number;
}>`
	color: ${(props) => props.color || defaultTextColor};
	opacity: ${(props) => props.opacity || 1};
	font-weight: 700;
	font-size: ${(props) => props.fontSize || "0.92em"};
	line-height: 1em;
	text-align: center;

	&.mt {
		margin-top: 0.6em;
	}

	&.mb {
		margin-bottom: 0.6em;
	}

	&.with-contrast {
		text-shadow: 0px 0px 0 #474747, -1px 1px 0 #474747, 1px -1px 0 #474747,
			-1px -1px 0 #474747, 0px 1px 0 #474747, 0px -1px 0 #474747,
			-1px 0px 0 #474747, 1px 0px 0 #474747, 1px 1px 0 #474747,
			-1px 1px 0 #474747, 1px -1px 0 #474747, -1px -1px 0 #474747,
			0px 1px 0 #474747, 0px -1px 0 #474747, -1px 0px 0 #474747,
			1px 0px 0 #474747, 1px 1px 0 #474747, -1px 1px 0 #474747,
			1px -1px 0 #474747, -1px -1px 0 #474747, 1px 1px 0 #474747,
			-1px 1px 0 #474747, 1px -1px 0 #474747, -1px -1px 0 #474747;
	}

	@media (max-width: 430px) {
		font-size: 14px;
	}
	@media (max-width: 414px) {
		font-size: 13px;
	}
	@media (max-width: 390px) {
		font-size: 12px;
	}
	@media (max-width: 375px) {
		font-size: 10px;
	}
	@media (max-width: 932px) and (max-height: 430px) {
		font-size: 0.8em;
	}

	&.waterfall {
		@media (min-width: 0px) {
			font-size: 1.7vw;
		}
		@media (min-width: 734px) {
			font-size: 0.8vw;
		}
		@media (min-width: 900px) {
			font-size: 0.9vw;
		}
		@media (min-width: 1200px) {
			font-size: 0.9vw;
		}
		@media (min-width: 1536px) {
			font-size: 14px;
		}
	}
`;

export const SwiperContainer = styled.div`
	.swiper-pagination {
		position: relative;
		margin-top: 10px;
	}

	.swiper-pagination-bullet {
		width: 10px;
		height: 10px;
		opacity: 1;
		background: #01a1bd;
	}

	.swiper-pagination-bullet-active {
		width: 10px;
		height: 10px;
		background: #eb5757;
	}

	&& .swiper-button-prev,
	&& .swiper-button-next {
		top: auto;
		bottom: 0;
		margin: 0 10px;
		margin-top: 0;
		background-color: rgba(0, 0, 0, 0.5);
		border-radius: 50%;
		color: white;
		width: 32px;
		height: 32px;
		--swiper-navigation-size: 32px;
		--swiper-navigation-color: white;

		&:after {
			font-size: 12px;
			font-weight: bold;
			-webkit-text-stroke-width: 0.5px;
			-webkit-text-stroke-color: white;
		}

		svg,
		.swiper-navigation-icon {
			width: 12px;
			height: 12px;
			color: white;
			fill: currentColor;
			stroke: currentColor;
			stroke-width: 3px;
		}

		&:hover {
			opacity: 0.8;
		}
	}

	&& .swiper-button-prev {
		left: 10px;
		right: auto;
	}

	&& .swiper-button-next {
		right: 10px;
		left: auto;
	}
`;

export const LoyaltyPointsV2 = styled.div<{
	fontSize?: string;
	padding?: string;
	position?: string;
}>`
	position: ${(props) => props.position || "relative"};

	border-radius: 16px;
	border: 1px solid #44c8df;
	background: rgba(0, 0, 0, 0.5);
	box-shadow: 0 0 10px 0 rgba(68, 200, 223, 0.95) inset;

	color: #fff;
	font-size: ${(props) => props.fontSize || "12px"};
	line-height: ${(props) => props.fontSize || "12px"};
	font-weight: 700;
	padding: ${(props) => props.padding || "4px 6px"};
	min-width: max-content;

	> div {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 3px;
	}
`;

export const Text = styled.div`
	//text-shadow: 0px 0.14em #000;
	//-webkit-text-stroke-width: 0.22em;
	//-webkit-text-stroke-color: #000;
	//paint-order: stroke fill;
	color: #fff;
	font-weight: 700;
	font-family: "inter";
`;

export const CrossedOutText = styled(Text)`
	font-size: 0.9em;
	line-height: 0.9em;
	color: #eb5757;
	position: relative;
	width: fit-content;
	&::after {
		content: "";
		position: absolute;
		width: calc(100% + 0.3em);
		left: -0.2em;
		top: 50%;
		transform: translateY(-50%);
		height: 0.14em;
		background: #eb5757;
		border-radius: 12px;
		pointer-events: none;
	}
`;

export const BestValueBadge = styled.div<{ backgroundImage: string }>`
	position: absolute;
	z-index: 1;
	font-size: 0.49em;
	top: -2.9em;
	right: -2.8em;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	background-image: url(${(props) => props.backgroundImage});
	background-size: cover;
	transform: rotate(-21deg);
	color: #fff;
	font-family: "Baloo";
	font-weight: 400;
	-webkit-text-stroke-width: ${isIOS ? "0.3em" : "0.4em"};
	-webkit-text-stroke-color: #474747;
	paint-order: stroke fill;
	transition: ease 0.3s;
	text-shadow: none;
	text-transform: none;

	> p {
		margin: 0;
		font-size: 2em;
		line-height: 0.8em;
	}

	> span {
		width: 5em;
		line-height: 0.8em;
		font-size: 1.55em;
	}

	&.disabled {
		filter: grayscale(1) brightness(45%);
	}
`;
